/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-computed-properties-in-native-classes, ember/no-get */
import { tracked } from '@glimmer/tracking';
import Controller from '@ember/controller';
import { action, computed } from '@ember/object';
import { service } from '@ember/service';
import { optionAlias } from '@linc-technologies/linced-common/utils/options';
import { isEmpty } from '@ember/utils';
import { alias } from '@ember/object/computed';
import { sortBy } from '@linc-technologies/linced-common/utils/arrays';

export default class TableController extends Controller {
  @action
  setSelectedSubcategory(value) {
    this.selectedSubcategory = value;
  }

  queryParams = [
    {
      currentTab: { as: 'table-currentTab' },
    },
  ];

  // Services
  @service
  options;

  @service
  session;

  @service
  store;

  //confirmed props
  @tracked
  selectedSubcategory = null;

  @tracked
  selectedCategory = null;
  @tracked sortProp = 'fullName';
  @tracked sortDir = 'asc';

  @alias('model.subject.isGradable')
  gradingEnabled;

  @computed('selectedCategory.sortedSubcategories.[]')
  get subcategoryOptions() {
    const defaultOption = { label: 'All', value: null };
    const sortedSubcategories =
      this.get('selectedCategory.sortedSubcategories') || [];
    return [defaultOption, ...sortedSubcategories];
  }

  @computed('model.group.currentLearners', 'sortProp', 'sortDir')
  get sortedLearners() {
    let people = sortBy(this.model.group.currentLearners, this.sortProp);

    return this.sortDir === 'asc' ? people : people.reverse();
  }

  @computed(
    'selectedCategory.sortedGoals.[]',
    'selectedSubcategory.sortedGoals.[]',
  )
  get sortedGoals() {
    if (isEmpty(this.selectedSubcategory)) {
      return this.get('selectedCategory.sortedGoals');
    }
    return this.get('selectedSubcategory.sortedGoals');
  }

  @optionAlias('hero:lock:milestones')
  milestonesLocked;

  initCategories() {
    let category = this.get('model.subject.sortedCategories.firstObject');
    this.selectedCategory = category;
  }

  @action
  noOp() {}

  @action
  selectCategory(category) {
    this.selectedCategory = category;
    this.selectedSubcategory = null;
  }

  @action
  refreshStates() {
    return this.model.states.update();
  }
}
